import { defineMessages } from 'react-intl';

import { PROPERTY_SHOW_QUERY_TYPES } from './constants';

const messages = defineMessages({
  [PROPERTY_SHOW_QUERY_TYPES.METERS]: {
    id: 'property.property_show.async_error_fallback.meters_query.body.message',
    defaultMessage: 'An error occurred while loading meters. Please try again.',
  },
  [PROPERTY_SHOW_QUERY_TYPES.RULES]: {
    id: 'property.property_show.async_error_fallback.rules_query.body.message',
    defaultMessage: 'An error occurred while loading rules. Please try again.',
  },
  [PROPERTY_SHOW_QUERY_TYPES.METER_DATA]: {
    id: 'property.property_show.async_error_fallback.meter_data_query.body.message',
    defaultMessage: 'An error occurred while loading meter data. Please try again.',
  },
  [PROPERTY_SHOW_QUERY_TYPES.METER_TRADE_SET_SUMMARY]: {
    id: 'property.property_show.async_error_fallback.meter_trade_set_summary_query.body.message',
    defaultMessage: 'An error occurred while loading meter trade set summaries. Please try again.',
  },
});

/**
 * Resolves the localized body text shown by `DashboardAsyncErrorFallback`
 * when a PropertyShow batched fetch fails. The fallback itself is feature-
 * agnostic; this helper keeps the PropertyShow vocabulary inside the
 * PropertyShow tree.
 * @param {object} intl - The react-intl `IntlShape` from `useIntl()`.
 * @param {string|null} queryType - One of `PROPERTY_SHOW_QUERY_TYPES`, or
 *   null when the failure has no associated query type.
 * @returns {string|null} The localized body message, or null when
 *   `queryType` is null or not in the lookup (callers should pass null to
 *   `DashboardAsyncErrorFallback` so its underlying modal renders its
 *   default body).
 */
export default function formatAsyncErrorBodyText(intl, queryType) {
  if (!queryType || !messages[queryType]) return null;
  return intl.formatMessage(messages[queryType]);
}
